import React from "react";
import { Box, Typography, Divider, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";

export interface LegalSection {
  heading: string;
  paragraphs: string[];
}

export interface LegalDocument {
  title: string;
  lastUpdated: string;
  effectiveDate: string;
  intro?: string;
  sections: LegalSection[];
}

interface LegalPageProps {
  legalDoc: LegalDocument;
}

const PageContainer = styled(Box)({
  maxWidth: 800,
  margin: "0 auto",
  padding: "32px 24px 64px",
});

const BackButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 6,
  color: "#2A7BFF",
  cursor: "pointer",
  fontSize: 14,
  fontWeight: 600,
  marginBottom: 32,
  width: "fit-content",
  "&:hover": { textDecoration: "underline" },
});

const LegalPage: React.FC<LegalPageProps> = ({ legalDoc }) => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <BackButton onClick={() => navigate("/settings")}>
        <ArrowBack sx={{ fontSize: 18 }} />
        Back to Settings
      </BackButton>

      <Typography variant="h2" fontWeight={700} mb={1}>
        {legalDoc.title}
      </Typography>

      <Typography fontSize={13} color="text.secondary" mb={1}>
        Effective Date: {legalDoc.effectiveDate}
      </Typography>
      <Typography fontSize={13} color="text.secondary" mb={4}>
        Last Updated: {legalDoc.lastUpdated}
      </Typography>

      {legalDoc.intro && (
        <Typography fontSize={15} color="text.secondary" mb={4} lineHeight={1.7}>
          {legalDoc.intro}
        </Typography>
      )}

      <Divider sx={{ mb: 4 }} />

      {legalDoc.sections.map((section: LegalSection, i: number) => (
        <Box key={i} mb={4}>
          <Typography fontWeight={700} fontSize={16} mb={1.5}>
            {section.heading}
          </Typography>
          {section.paragraphs.map((para: string, j: number) => (
            <Typography key={j} fontSize={14} lineHeight={1.8} color="#333" mb={1.5}>
              {para}
            </Typography>
          ))}
        </Box>
      ))}
    </PageContainer>
  );
};

export default LegalPage;